module.exports = __webpack_public_path__ + "static/urban7-58f57709f5ac29f517b7593dfa59f773.jpg";